import { objectTranslator } from "@towni/common";
import { useSelectedLanguageCode } from "./use-selected-language-code";

const useObjectTranslator = () => {
    const language = useSelectedLanguageCode();
    return objectTranslator(language);
};

export { useObjectTranslator };
